import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, inject } from '@angular/core';
import { ConfigService } from 'src/services/config.service';
import { configModel } from 'src/models/config.model';
import { Router, RouterModule } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ParticipantService } from 'src/services/participant.service';
import { AuthStore } from 'src/app/store/authorization/auth.store';
import { SHARED_IMPORTS } from 'src/app/shared/shared.module';
import { ParticipantStudyListComponent as LsrParticipantStudyListComponent } from '../../../LSR/participant/participant_study_list/participant_study_list.component';
import { ParticipantReferComponent } from '../participant_refer/participant_refer.component';

@Component({
  selector: 'app-lsr-participanthome',
  templateUrl: './participant_home.component.html',
  styleUrls: ['./participant_home.component.css'],
  standalone: true,
  imports: [...SHARED_IMPORTS,LsrParticipantStudyListComponent, ParticipantReferComponent,RouterModule]
})
export class ParticipantHomeComponent implements OnInit {
  configModel: configModel;
  hcontact: string;
  aboutus: string;
  originalAboutus: string;
  editConfigVisible = false;
  isEditable: boolean = false;
  isAdminUser = false;
  @ViewChild('aboutUsTextarea') aboutUsTextarea: ElementRef;
  imageSrc: string;
  isLoading: boolean = false;
  isUploading: boolean = false;
  uploadProgress: number = 0;
  userNotification: string;
  isNotificationDismissed: boolean = false;
  showBellIcon: boolean = false;

  private readonly authStore = inject(AuthStore);

  constructor(private configService: ConfigService, private router: Router, private cdr: ChangeDetectorRef, private participantService: ParticipantService) { }

  ngOnInit() {
    this.configService.isConfigLoaded().subscribe(loaded => {
      if (loaded) {
        this.loadImage();
        let configModel = this.configService.getConfigModel();
        this.aboutus = configModel.getConfigkeyname('About_Us');
        this.userNotification = configModel.getConfigkeyname('Banner_Message');
        this.originalAboutus = this.aboutus;
        this.cdr.markForCheck();
      }
    });

    // Fallback to load image immediately
    this.loadImage();

  }

  loadImage(): void {
    this.isLoading = true;
    this.configService.getCurrentImage().subscribe(response => {
      Promise.resolve().then(() => {
      const data = JSON.parse(response.imageUrl);
      this.imageSrc = data.imageUrl;
      this.isLoading = false;
      this.cdr.markForCheck();
      });
    });
  }

  dismissNotification(): void {
    this.isNotificationDismissed = true;
    this.showBellIcon = true;
  }

  goToStudyDetail(event: Event): void {
    event.preventDefault();

    this.participantService.getStudyList().subscribe(studies => {
      const firstStudyId = studies?.[0]?.studyId;

      if (firstStudyId) {
        this.router.navigate(['/ParticipantStudyDetail', firstStudyId], {
          state: { IsRefered: 'false' }
        });
      }
    });
  }

  toggleNotification(): void {
    this.showBellIcon = false;
    if (!this.isNotificationDismissed) return;
    if (this.userNotification) {
      this.isNotificationDismissed = false;
    }
  }
}
